import { render, staticRenderFns } from "./MeasurementsFitsModular.vue?vue&type=template&id=005e91da&scoped=true&"
import script from "./MeasurementsFitsModular.vue?vue&type=script&lang=js&"
export * from "./MeasurementsFitsModular.vue?vue&type=script&lang=js&"
import style0 from "./MeasurementsFitsModular.vue?vue&type=style&index=0&id=005e91da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005e91da",
  null
  
)

export default component.exports